import React from "react";
import "antd/dist/antd.css";
import { Upload, Icon, message, Button } from 'antd';
import './ImageUpload.scss'

export default function ImageUpload(propsComponent) {

	const uploadButton = (
		<div className={propsComponent.overlayKey + ' image-upload-control'}>
			<div className="overlay">
				<Icon type={propsComponent.isLoading ? 'loading' : 'plus'} />
				<div className="ant-upload-text">{propsComponent.label}</div>
			</div>
		</div>
	);

	const removeFile = (e) => {
		if (propsComponent.fileList[0]) {
			propsComponent.onFileRemoved(propsComponent.fileList[0]);
			propsComponent.setFilePreview('');
			propsComponent.setFileList([]);
		}
		e.stopPropagation();
	}

	const getBase64 = function (img, callback) {
		const reader = new FileReader();
		reader.addEventListener('load', () => callback(reader.result));
		reader.readAsDataURL(img);
	}

	const handleChange = info => {

		if (!info.file.status) { //Intercepted file by beforeUpload don't have status field.
			return;
		}

		if (info.file.status === 'uploading') {
			propsComponent.setIsLoading(true);
		}

		if (info.file.status === 'done') {
			propsComponent.setIsLoading(false);
			propsComponent.onFileUpload({side: propsComponent.side, file: info.file.originFileObj, checkResult: info.file.response});
		}

		if (info.file.status === 'error') {
			propsComponent.setIsLoading(false);
			message.error('Failed to upload file');
		}

		let fl = [...info.fileList];

		fl = fl.slice(fl.length - 1);

		fl = fl.map(file => {

			if (file.response) {
				file.checkResult = file.response;
				file.originalFile = file.originFileObj;
				getBase64(file.originFileObj, imageUrl => {
					propsComponent.setFilePreview(imageUrl);
					propsComponent.onPreviewLoad(imageUrl);
				})
			}
			return file;
		});

		propsComponent.setFileList(fl);
	};

	const beforeUpload = function (fileToUpload) {

	    propsComponent.checkSessionExpired();

		propsComponent.setIsLoading(true);

		const isJpgOrPng = fileToUpload.type === 'image/jpeg' || fileToUpload.type === 'image/png';
		if (!isJpgOrPng) {
			message.error('You can only upload JPG/PNG file!');
			propsComponent.setIsLoading(false);
			return false;
		}
		const isLt5M = fileToUpload.size / 1024 / 1024 < 5;
		if (!isLt5M) {
			message.error('Image must smaller than 5MB!');
			propsComponent.setIsLoading(false);
			return false;
		}

		if (propsComponent.fileList.length > 0) {
			propsComponent.onFileRemoved(propsComponent.fileList[0].originalFile);
		}
	}

	return (
		<div>
			<Upload
			    accept="image/png, image/jpeg"
				name="image"
				action="/api/checkImage"
				listType="picture-card"
				className="avatar-uploader"
				beforeUpload={beforeUpload}
				showUploadList={false}
				onChange={handleChange}
				fileList={propsComponent.fileList}

			>
				{propsComponent.fileList && propsComponent.fileList.length > 0 && propsComponent.filePreview ?
					<div className="file-preview">
						<img src={propsComponent.filePreview} alt="avatar" style={{ width: '100%' }} />
						<div className="overlay">
							<Button type="link" onClick={removeFile}>
								<Icon type='delete' /></Button>
						</div>
					</div> : uploadButton}
			</Upload>
			{propsComponent.fileList && propsComponent.fileList.length > 0 && propsComponent.fileList[0].checkResult &&
				<div className="image-status">
					{propsComponent.fileList[0].checkResult.applicable ?
						<div className="success"><Icon type="check" /> Applicable</div> :
						<div className="error"><Icon type="close" /> Not applicable</div>}
					{propsComponent.fileList[0].checkResult.gradable ?
						<div className="success"><Icon type="check" /> Gradable</div> :
						<div className="error"><Icon type="close" /> Not gradable</div>}
				</div>
			}
		</div>
	)
}